import React from 'react'

const EyeGreenSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 15.117 10.307'
    >
      <g id='out' transform='translate(-1.167 -5.25)'>
        <path
          id='path'
          d='M8.725,5.25A8.127,8.127,0,0,0,1.167,10.4a8.12,8.12,0,0,0,15.117,0A8.127,8.127,0,0,0,8.725,5.25Zm0,8.589A3.436,3.436,0,1,1,12.161,10.4a3.437,3.437,0,0,1-3.436,3.436Zm0-5.5A2.061,2.061,0,1,0,10.787,10.4,2.059,2.059,0,0,0,8.725,8.342Z'
          fill='#205c42'
          fillRule='evenodd'
        />
      </g>
    </svg>
  )
}

export default EyeGreenSvg
